module.exports = __webpack_public_path__ + "static/media/0010_LE_PLAFOND_CHROMATIC_CH2_1039.751ba927.png";